import React from 'react';
import cn from 'classnames';
import CollapseEl from 'components/UI/CollapseEl';

import * as styles from './DropDownList.module.scss';

function DropDownList({ title, children, isOpened, toggleListHandler }) {
  return (
    <div className={styles.wrapper}>
      <button
        onClick={toggleListHandler}
        className={cn(styles.countryBtn, isOpened && styles.active)}
      >
        <span className={styles.title}>{title}</span>
      </button>
      <CollapseEl toggle={isOpened}>{children}</CollapseEl>
    </div>
  );
}

export default DropDownList;
